module.exports = __webpack_public_path__ + "static/avatar-64b2f36b53a3225f6960e3feeb38c30d.jpg";